<!-- position: relative added in order for the loading indicator to be positioned correctly -->
<div
  class="te-calendar--container loading-indicator--location"
  [attr.data-indicator-name]="'table'"
  style="position: relative"
  >
  @if (memoizedCreateAllowed) {
    <button
      class="button te-calendar--create-button"
      [attr.aria-label]="text.logTime"
      (click)="addEventToday()"
      >
      <op-icon icon-classes="button--icon icon-log_time" />
      <span
        class="button--text"
        [textContent]="text.logTime"
        aria-hidden="true"
      ></span>
    </button>
  }
  @if ((calendarOptions$ | async); as calendarOptions) {
    @if (calendarOptions) {
      <full-calendar #ucCalendar
        [options]="calendarOptions"
       />
    }
  }
</div>
